(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var home = document.getElementById('kyzen-home');
    if (!home) return;
    document.body.classList.add('kyzen-home-template');

    var menuButton = home.querySelector('[data-ky-menu-button]');
    var mobileMenu = home.querySelector('[data-ky-mobile-menu]');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', function () {
        var opening = mobileMenu.hasAttribute('hidden');
        mobileMenu.toggleAttribute('hidden', !opening);
        menuButton.setAttribute('aria-expanded', String(opening));
      });
      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileMenu.setAttribute('hidden', '');
          menuButton.setAttribute('aria-expanded', 'false');
        });
      });
    }

    var search = home.querySelector('[data-ky-search]');
    var searchOpen = home.querySelector('[data-ky-search-open]');
    var searchClose = home.querySelector('[data-ky-search-close]');
    var searchInput = home.querySelector('[data-ky-search-input]');
    function closeSearch() {
      if (!search) return;
      search.setAttribute('hidden', '');
      document.body.classList.remove('ky-search-open');
      if (searchOpen) searchOpen.focus();
    }
    if (search && searchOpen && searchClose) {
      searchOpen.addEventListener('click', function () {
        search.removeAttribute('hidden');
        document.body.classList.add('ky-search-open');
        if (searchInput) searchInput.focus();
      });
      searchClose.addEventListener('click', closeSearch);
      search.addEventListener('click', function (event) {
        if (event.target === search) closeSearch();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !search.hasAttribute('hidden')) closeSearch();
      });
    }

    home.querySelectorAll('[data-ky-feature-carousel]').forEach(function (carousel) {
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-ky-feature-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-ky-feature-dot]'));
      var previous = carousel.querySelector('[data-ky-feature-prev]');
      var next = carousel.querySelector('[data-ky-feature-next]');
      var delay = Number(carousel.getAttribute('data-autoplay-ms')) || 5000;
      var current = 0;
      var timer = null;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length < 2) return;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.setAttribute('tabindex', active ? '0' : '-1');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function pause() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function play() {
        pause();
        if (!reducedMotion && !document.hidden) {
          timer = window.setInterval(function () { show(current + 1); }, delay);
        }
      }

      function choose(index) {
        show(index);
        play();
      }

      if (previous) previous.addEventListener('click', function () { choose(current - 1); });
      if (next) next.addEventListener('click', function () { choose(current + 1); });
      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () { choose(dotIndex); });
      });
      carousel.addEventListener('mouseenter', pause);
      carousel.addEventListener('mouseleave', play);
      carousel.addEventListener('focusin', pause);
      carousel.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!carousel.contains(document.activeElement)) play();
        }, 0);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) pause();
        else play();
      });

      show(0);
      play();
    });

    var filters = home.querySelectorAll('[data-ky-filter]');
    var productCards = home.querySelectorAll('[data-ky-product-card]');
    var empty = home.querySelector('[data-ky-empty]');
    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        var term = (button.getAttribute('data-ky-filter') || '').toLowerCase();
        var visible = 0;
        filters.forEach(function (item) { item.classList.toggle('on', item === button); });
        productCards.forEach(function (card) {
          var haystack = (card.getAttribute('data-ky-product-card') || '').toLowerCase();
          var show = !term || haystack.indexOf(term) !== -1;
          card.toggleAttribute('hidden', !show);
          if (show) visible += 1;
        });
        if (empty) empty.toggleAttribute('hidden', visible !== 0);
      });
    });
  });
})();
